module.exports = __webpack_public_path__ + "banner2.c2ec6b8ac2a6443487f7.png";